import React from 'react';
export { default as Groceries } from './groceries.svg';

export interface GikIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const GikIconDefaultSize = 24;

export { default as ShareAlt } from './ShareAlt';
export * from './Eat';
export * from './CoverSettings';
export * from './Reminder';
export * from './Fundraising';
export * from './FundraisingThin';
export * from './Calendar';
export * from './Wishlist';
export * from './WishlistLarge';
export * from './InterrogationRed';
export * from './Play';
export * from './PhoneCallsOk';
export * from './PhoneCallsDisabled';
export * from './FlowersOk';
export * from './FlowersDisabled';
export * from './TextMessagesOk';
export * from './TextMessagesDisabled';
export * from './VisitorsOk';
export * from './VisitorsDisabled';
export * from './PageSharingOk';
export * from './PageSharingDisabled';
export * from './Features';
export * from './DragDoubleArrow';
